<div class="modal-header justify-content-between align-items-center">
    <div class="text-primary t-20 t-sb" data-test="confirm-button-title">{{ title | translate }}</div>
    <button [hoverEffect]="false" (click)="close()" appButtonIcon data-test="confirm-button-close" iconSize="small">
        <svg-icon src="assets/icons/Close.svg" svgClass="close"></svg-icon>
    </button>
</div>
<div class="modal-body" [innerHTML]="text" data-test="confirm-button-text"></div>
<div class="modal-footer">
    <ng-container *ngIf="warn; else noWarn">
        <button (click)="confirm()" data-test="confirm-button-warn" appButtonFlat size="small">
            {{ 'modal.ok' | translate }}
        </button>
    </ng-container>
    <ng-template #noWarn>
        <button [hoverEffect]="false" (click)="decline()" data-test="confirm-button-decline" appButtonStroked>
            {{ 'modal.no' | translate }}
        </button>
        <button class="ms-2" (click)="confirm()" data-test="confirm-button-confirm" appButtonFlat>
            {{ 'modal.yes' | translate }}
        </button>
    </ng-template>
</div>
